// Super admin → Automation → Lifecycle (`super_admin/lifecycle/`): when the platform's
// built-in trial/dunning/cancellation emails fire, whether each is on, and how long the
// trial and grace windows are. The email TEXT stays in `backend/emails/platform.py`'s own
// fr/en/es templates — nothing here is copy the operator writes.
// Contract: docs/automation-module/lifecycle-policy-contract.md.
export default {
  fr: {
    "lifecycle.tabs.lifecycle": "Cycle de vie",
    "lifecycle.tabs.customRules": "Règles personnalisées",

    "lifecycle.loading": "Chargement…",
    "lifecycle.loadFailed": "La politique de cycle de vie n'a pas pu être chargée.",
    "lifecycle.title": "E-mails de cycle de vie",
    "lifecycle.subtitle": "Le moment et l'activation de chaque e-mail automatique. Le texte des e-mails n'est pas modifiable ici.",
    "lifecycle.saved": "Enregistré",
    "lifecycle.unsavedChanges": "Modifications non enregistrées",
    "lifecycle.save": "Enregistrer",
    "lifecycle.reset": "Annuler les modifications",
    "lifecycle.lastSaved": "Dernier enregistrement le {at} par {who}",
    "lifecycle.confirmTitle": "Confirmer les modifications",
    "lifecycle.confirmDesc": "Cette action change le calendrier des e-mails envoyés aux cabinets. Confirmez votre identité pour continuer.",
    "lifecycle.ack": "Je confirme ces modifications.",

    "lifecycle.other.title": "Bienvenue & abonnement",

    "lifecycle.trial.title": "Essai gratuit",
    "lifecycle.trial.lengthLabel": "Durée de l'essai (jours)",
    "lifecycle.trial.lengthHint": "{min} à {max} jours.",
    "lifecycle.trial.newSignupsOnly": "Une modification s'applique uniquement aux nouvelles inscriptions : un essai déjà en cours garde sa durée d'origine.",
    "lifecycle.trial.remindersTitle": "Rappels avant la fin de l'essai (en jours restants)",
    "lifecycle.trial.remindersHint": "Jusqu'à {max} rappels, chacun avant la fin de l'essai.",

    "lifecycle.dunning.title": "Recouvrement (impayés)",
    "lifecycle.dunning.graceLabel": "Délai de grâce avant suspension (jours)",
    "lifecycle.dunning.graceHint": "{min} à {max} jours après le premier échec de paiement.",
    "lifecycle.dunning.followUpsTitle": "Relances après le premier échec (en jours écoulés)",
    "lifecycle.dunning.followUpsHint": "Chaque relance doit tomber avant la suspension, c'est-à-dire avant l'échéance du délai de grâce.",

    "lifecycle.cancellation.title": "Résiliation",

    "lifecycle.dayInput.invalid": "Indiquez un nombre entier.",
    "lifecycle.dayInput.range": "Indiquez un nombre entre {min} et {max}.",
    "lifecycle.dayInput.duplicate": "Ce jour est déjà dans la liste.",
    "lifecycle.dayInput.remove": "Retirer {n} jours",
    "lifecycle.dayInput.empty": "Aucun.",
    "lifecycle.dayInput.addLabel": "Ajouter un jour",
    "lifecycle.dayInput.add": "Ajouter",
    "lifecycle.leadDay.unit": "{n} jours avant",
    "lifecycle.followUpDay.unit": "Jour {n}",

    "lifecycle.upcoming.title": "Envois à venir",
    "lifecycle.upcoming.runNow": "Lancer maintenant",
    "lifecycle.upcoming.running": "En cours…",
    "lifecycle.upcoming.empty": "Rien de prévu.",
    "lifecycle.run.result": "{sent} envoyé(s) · {skipped} ignoré(s) · {failed} échoué(s)",
    "lifecycle.sends.title": "Envois récents",
    "lifecycle.sends.empty": "Aucun envoi pour le moment.",

    "lifecycle.stripeNote.title": "Contrôlé par Stripe",
    "lifecycle.stripe.smart_retries": "Nouvelles tentatives intelligentes — Stripe décide quand réessayer une carte refusée.",
    "lifecycle.stripe.checkout_session_ttl": "Durée de validité de la session de paiement.",

    "lifecycle.violation.unknown_field": "Ce champ n'est pas reconnu.",
    "lifecycle.violation.type": "Le type de cette valeur est incorrect.",
    "lifecycle.violation.min": "Cette valeur est trop basse.",
    "lifecycle.violation.max": "Cette valeur est trop élevée.",
    "lifecycle.violation.unique": "Chaque valeur doit être unique.",
    "lifecycle.violation.max_items": "Trop d'éléments dans la liste.",
    "lifecycle.violation.lt_trial_length": "Chaque rappel doit tomber avant la fin de l'essai.",
    "lifecycle.violation.lt_grace_days": "Chaque relance doit tomber avant la suspension.",

    "lifecycle.error.POLICY_INVALID": "Certaines valeurs ne sont pas valides : corrigez les champs signalés ci-dessous.",
    "lifecycle.error.REAUTH_REQUIRED": "La vérification d'identité a expiré. Réessayez.",
    "lifecycle.error.INVALID_HORIZON": "L'horizon demandé n'est pas valide.",
    "lifecycle.error.UNKNOWN": "Une erreur inconnue est survenue.",

    "lifecycle.moment.welcome": "Bienvenue",
    "lifecycle.moment.trial_reminder": "Rappel de fin d'essai",
    "lifecycle.moment.trial_converted": "Essai converti en abonnement payant",
    "lifecycle.moment.dunning_first_notice": "Premier avis d'échec de paiement",
    "lifecycle.moment.dunning_follow_up": "Relance d'impayé",
    "lifecycle.moment.suspended_non_payment": "Suspension pour impayé",
    "lifecycle.moment.subscription_cancelled": "Abonnement résilié",
    "lifecycle.moment.service_ended": "Fin de service",
    "lifecycle.moment.plan_changed": "Changement de forfait",

    "lifecycle.outcome.sent": "envoyé",
    "lifecycle.outcome.no_transport": "sans transport d'e-mail",
    "lifecycle.outcome.failed": "échoué",
    "lifecycle.outcome.skipped_disabled": "ignoré (désactivé)",
  },
  en: {
    "lifecycle.tabs.lifecycle": "Lifecycle",
    "lifecycle.tabs.customRules": "Custom rules",

    "lifecycle.loading": "Loading…",
    "lifecycle.loadFailed": "The lifecycle policy could not be loaded.",
    "lifecycle.title": "Lifecycle emails",
    "lifecycle.subtitle": "When each built-in email fires and whether it is on. The email text is not editable here.",
    "lifecycle.saved": "Saved",
    "lifecycle.unsavedChanges": "Unsaved changes",
    "lifecycle.save": "Save",
    "lifecycle.reset": "Discard changes",
    "lifecycle.lastSaved": "Last saved {at} by {who}",
    "lifecycle.confirmTitle": "Confirm these changes",
    "lifecycle.confirmDesc": "This changes the schedule of emails sent to practices. Confirm your identity to continue.",
    "lifecycle.ack": "I confirm these changes.",

    "lifecycle.other.title": "Welcome & subscription",

    "lifecycle.trial.title": "Free trial",
    "lifecycle.trial.lengthLabel": "Trial length (days)",
    "lifecycle.trial.lengthHint": "{min} to {max} days.",
    "lifecycle.trial.newSignupsOnly": "A change applies to new signups only — a practice already on trial keeps its original window.",
    "lifecycle.trial.remindersTitle": "Reminders before the trial ends (days left)",
    "lifecycle.trial.remindersHint": "Up to {max} reminders, each before the trial ends.",

    "lifecycle.dunning.title": "Payment recovery (dunning)",
    "lifecycle.dunning.graceLabel": "Grace days before suspension",
    "lifecycle.dunning.graceHint": "{min} to {max} days after the first failed charge.",
    "lifecycle.dunning.followUpsTitle": "Follow-ups after the first failure (days elapsed)",
    "lifecycle.dunning.followUpsHint": "Every follow-up must fall before the suspension — that is, before the grace deadline.",

    "lifecycle.cancellation.title": "Cancellation",

    "lifecycle.dayInput.invalid": "Enter a whole number.",
    "lifecycle.dayInput.range": "Enter a number from {min} to {max}.",
    "lifecycle.dayInput.duplicate": "That day is already in the list.",
    "lifecycle.dayInput.remove": "Remove {n} days",
    "lifecycle.dayInput.empty": "None.",
    "lifecycle.dayInput.addLabel": "Add a day",
    "lifecycle.dayInput.add": "Add",
    "lifecycle.leadDay.unit": "{n} days before",
    "lifecycle.followUpDay.unit": "Day {n}",

    "lifecycle.upcoming.title": "Upcoming sends",
    "lifecycle.upcoming.runNow": "Run now",
    "lifecycle.upcoming.running": "Running…",
    "lifecycle.upcoming.empty": "Nothing scheduled.",
    "lifecycle.run.result": "{sent} sent · {skipped} skipped · {failed} failed",
    "lifecycle.sends.title": "Recent sends",
    "lifecycle.sends.empty": "No sends yet.",

    "lifecycle.stripeNote.title": "Controlled by Stripe",
    "lifecycle.stripe.smart_retries": "Smart retries — Stripe decides when to retry a declined card.",
    "lifecycle.stripe.checkout_session_ttl": "Checkout session expiry.",

    "lifecycle.violation.unknown_field": "This field is not recognized.",
    "lifecycle.violation.type": "This value has the wrong type.",
    "lifecycle.violation.min": "This value is too low.",
    "lifecycle.violation.max": "This value is too high.",
    "lifecycle.violation.unique": "Every value must be unique.",
    "lifecycle.violation.max_items": "Too many items in the list.",
    "lifecycle.violation.lt_trial_length": "Every reminder must fall before the trial ends.",
    "lifecycle.violation.lt_grace_days": "Every follow-up must fall before the suspension.",

    "lifecycle.error.POLICY_INVALID": "Some values are invalid — fix the fields flagged below.",
    "lifecycle.error.REAUTH_REQUIRED": "Identity verification expired. Try again.",
    "lifecycle.error.INVALID_HORIZON": "The requested horizon is invalid.",
    "lifecycle.error.UNKNOWN": "Something went wrong.",

    "lifecycle.moment.welcome": "Welcome",
    "lifecycle.moment.trial_reminder": "Trial ending reminder",
    "lifecycle.moment.trial_converted": "Trial converted to a paid plan",
    "lifecycle.moment.dunning_first_notice": "First payment-failure notice",
    "lifecycle.moment.dunning_follow_up": "Payment follow-up",
    "lifecycle.moment.suspended_non_payment": "Suspended for non-payment",
    "lifecycle.moment.subscription_cancelled": "Subscription cancelled",
    "lifecycle.moment.service_ended": "Service ended",
    "lifecycle.moment.plan_changed": "Plan changed",

    "lifecycle.outcome.sent": "sent",
    "lifecycle.outcome.no_transport": "no email transport",
    "lifecycle.outcome.failed": "failed",
    "lifecycle.outcome.skipped_disabled": "skipped (disabled)",
  },
  es: {
    "lifecycle.tabs.lifecycle": "Ciclo de vida",
    "lifecycle.tabs.customRules": "Reglas personalizadas",

    "lifecycle.loading": "Cargando…",
    "lifecycle.loadFailed": "No se pudo cargar la política de ciclo de vida.",
    "lifecycle.title": "Correos de ciclo de vida",
    "lifecycle.subtitle": "Cuándo se envía cada correo integrado y si está activado. El texto del correo no es editable aquí.",
    "lifecycle.saved": "Guardado",
    "lifecycle.unsavedChanges": "Cambios sin guardar",
    "lifecycle.save": "Guardar",
    "lifecycle.reset": "Descartar cambios",
    "lifecycle.lastSaved": "Guardado por última vez el {at} por {who}",
    "lifecycle.confirmTitle": "Confirmar estos cambios",
    "lifecycle.confirmDesc": "Esto cambia el calendario de correos enviados a los consultorios. Confirme su identidad para continuar.",
    "lifecycle.ack": "Confirmo estos cambios.",

    "lifecycle.other.title": "Bienvenida y suscripción",

    "lifecycle.trial.title": "Prueba gratuita",
    "lifecycle.trial.lengthLabel": "Duración de la prueba (días)",
    "lifecycle.trial.lengthHint": "De {min} a {max} días.",
    "lifecycle.trial.newSignupsOnly": "Un cambio se aplica solo a las nuevas inscripciones: una prueba ya en curso conserva su duración original.",
    "lifecycle.trial.remindersTitle": "Recordatorios antes de que termine la prueba (días restantes)",
    "lifecycle.trial.remindersHint": "Hasta {max} recordatorios, cada uno antes de que termine la prueba.",

    "lifecycle.dunning.title": "Recuperación de pagos (morosidad)",
    "lifecycle.dunning.graceLabel": "Días de gracia antes de la suspensión",
    "lifecycle.dunning.graceHint": "De {min} a {max} días después del primer pago fallido.",
    "lifecycle.dunning.followUpsTitle": "Seguimientos tras el primer fallo (días transcurridos)",
    "lifecycle.dunning.followUpsHint": "Cada seguimiento debe caer antes de la suspensión, es decir, antes del plazo de gracia.",

    "lifecycle.cancellation.title": "Cancelación",

    "lifecycle.dayInput.invalid": "Indique un número entero.",
    "lifecycle.dayInput.range": "Indique un número entre {min} y {max}.",
    "lifecycle.dayInput.duplicate": "Ese día ya está en la lista.",
    "lifecycle.dayInput.remove": "Quitar {n} días",
    "lifecycle.dayInput.empty": "Ninguno.",
    "lifecycle.dayInput.addLabel": "Añadir un día",
    "lifecycle.dayInput.add": "Añadir",
    "lifecycle.leadDay.unit": "{n} días antes",
    "lifecycle.followUpDay.unit": "Día {n}",

    "lifecycle.upcoming.title": "Envíos próximos",
    "lifecycle.upcoming.runNow": "Ejecutar ahora",
    "lifecycle.upcoming.running": "En curso…",
    "lifecycle.upcoming.empty": "Nada programado.",
    "lifecycle.run.result": "{sent} enviado(s) · {skipped} omitido(s) · {failed} fallido(s)",
    "lifecycle.sends.title": "Envíos recientes",
    "lifecycle.sends.empty": "Todavía no hay envíos.",

    "lifecycle.stripeNote.title": "Controlado por Stripe",
    "lifecycle.stripe.smart_retries": "Reintentos inteligentes: Stripe decide cuándo reintentar una tarjeta rechazada.",
    "lifecycle.stripe.checkout_session_ttl": "Duración de la sesión de pago.",

    "lifecycle.violation.unknown_field": "Este campo no se reconoce.",
    "lifecycle.violation.type": "El tipo de este valor es incorrecto.",
    "lifecycle.violation.min": "Este valor es demasiado bajo.",
    "lifecycle.violation.max": "Este valor es demasiado alto.",
    "lifecycle.violation.unique": "Cada valor debe ser único.",
    "lifecycle.violation.max_items": "Demasiados elementos en la lista.",
    "lifecycle.violation.lt_trial_length": "Cada recordatorio debe caer antes de que termine la prueba.",
    "lifecycle.violation.lt_grace_days": "Cada seguimiento debe caer antes de la suspensión.",

    "lifecycle.error.POLICY_INVALID": "Algunos valores no son válidos: corrija los campos señalados abajo.",
    "lifecycle.error.REAUTH_REQUIRED": "La verificación de identidad expiró. Inténtelo de nuevo.",
    "lifecycle.error.INVALID_HORIZON": "El horizonte solicitado no es válido.",
    "lifecycle.error.UNKNOWN": "Ocurrió un error desconocido.",

    "lifecycle.moment.welcome": "Bienvenida",
    "lifecycle.moment.trial_reminder": "Recordatorio de fin de prueba",
    "lifecycle.moment.trial_converted": "Prueba convertida en plan de pago",
    "lifecycle.moment.dunning_first_notice": "Primer aviso de pago fallido",
    "lifecycle.moment.dunning_follow_up": "Seguimiento de impago",
    "lifecycle.moment.suspended_non_payment": "Suspendido por impago",
    "lifecycle.moment.subscription_cancelled": "Suscripción cancelada",
    "lifecycle.moment.service_ended": "Servicio finalizado",
    "lifecycle.moment.plan_changed": "Plan modificado",

    "lifecycle.outcome.sent": "enviado",
    "lifecycle.outcome.no_transport": "sin transporte de correo",
    "lifecycle.outcome.failed": "fallido",
    "lifecycle.outcome.skipped_disabled": "omitido (desactivado)",
  },
};
